// extracted by mini-css-extract-plugin
export default {"about-container":"About_about-container__ZuZgu","image-carousel":"About_image-carousel__NHZF0"};